import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
import store from './index';
export default {
  store: store,
  install: function install(Vue) {
    var vueInstance = Vue;
    vueInstance.prototype.$store = store();
  }
};